/**
 * Single registration point for GSAP + the plugins this site uses.
 * Importing anywhere else risks double-registration warnings and
 * plugin-tree-shaking surprises in CRA.
 */
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger, SplitText, useGSAP);

/** Motion language: four verbs, two curves. */
export const EASE = {
  out: "power4.out",
  io: "expo.inOut",
  soft: "power2.out",
};

export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export { gsap, ScrollTrigger, SplitText, useGSAP };
